import React from 'react';
import './specifications.component.sass';
import {Nav, List, Row, Col} from "rsuite";
import {connect} from 'react-redux';
import {createStructuredSelector} from "reselect";
import {selectSelectedProduct, selectTecOrAttr} from "../../redux/site/site.selector";
import {ToggleTecAttr} from "../../redux/site/site.actions";
import tecData from '../../data/tecAndAttr/Technical';
import AttrData from '../../data/tecAndAttr/Attr';

const SpecificationsComponent = ({attrOrTec, ToggleAttrTec, Product}) => {
    const TabsSelector = () => {
        switch (attrOrTec) {
            case 'Technical':
                return(
                    <div>
                        <List hover>
                            {Product.ProductProp.map((item, index) => (
                                <List.Item key={index} index={index}>
                                    <Row>
                                        <Col xs={8}>
                                            {item.unit}
                                        </Col>
                                        <Col xs={8}>
                                            {item.value}
                                        </Col>
                                        <Col xs={8}>
                                            {item.name}
                                        </Col>
                                    </Row>
                                </List.Item>
                            ))}
                        </List>
                    </div>
                );
            case 'Attributes':
                return(
                    <div>
                        <List hover>
                            {Product.ProductSpecific.map((item, i)=>(
                                <List.Item key={i} index={i}>
                                    <Row>
                                        <Col xs={22} md={23}>
                                            {item.name}
                                        </Col>
                                        <Col xs={2} md={1}>
                                            <span className='attr-number'>{i + 1}</span>
                                        </Col>
                                    </Row>
                                </List.Item>
                            ))}
                        </List>
                    </div>
                );
        }
    };
    return (
        <div className='attr-tec-area'>
            <Nav appearance='tabs' activeKey={attrOrTec} onSelect={(val)=>ToggleAttrTec(val)}>
                <Nav.Item eventKey="Technical">مشخصات فنی</Nav.Item>
                <Nav.Item eventKey="Attributes">ویژگی ها</Nav.Item>
            </Nav>
            <div>
                <TabsSelector />
            </div>
        </div>
    );
};
const mapStateToProps = createStructuredSelector({
    attrOrTec : selectTecOrAttr,
    Product : selectSelectedProduct
});
const mapDispatchToProps = dispatch => ({
    ToggleAttrTec : tecAttr => dispatch(ToggleTecAttr(tecAttr))
});
export default connect(mapStateToProps, mapDispatchToProps)(SpecificationsComponent);